"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * Possible improvements:
 * 1. Compute scroll position for next highlight index before changing the index - use same render
 * 2. scroll to currently selected when it's under the fold not working for enter key open
 */

var useHighlightInteraction = function useHighlightInteraction(highlightIndex) {
  // highlighting current item
  var highlightedItemRef = (0, _react.useRef)(null);
  var listContainerRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    shouldScrollToHighlight = _useState2[0],
    setShouldScrollToHighlight = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    withoutMouseHighlight = _useState4[0],
    setWithoutMouseHighlight = _useState4[1];
  var scrollToHighlight = (0, _react.useCallback)(function () {
    return setShouldScrollToHighlight(true);
  }, []);
  var preventScrollToHighlight = (0, _react.useCallback)(function () {
    return setShouldScrollToHighlight(false);
  }, []);
  var disableMouseHighlighting = (0, _react.useCallback)(function () {
    return setWithoutMouseHighlight(true);
  }, []);
  (0, _react.useEffect)(function () {
    // bring the selected item into view when browsing the list with the arrow keys
    if (!highlightedItemRef.current || !shouldScrollToHighlight) {
      return;
    }
    if (highlightedItemRef.current.offsetTop + highlightedItemRef.current.offsetHeight >= listContainerRef.current.offsetHeight + listContainerRef.current.scrollTop) {
      listContainerRef.current.scrollTop = highlightedItemRef.current.offsetTop + highlightedItemRef.current.offsetHeight - listContainerRef.current.offsetHeight;
    } else if (highlightedItemRef.current.offsetTop < listContainerRef.current.scrollTop) {
      listContainerRef.current.scrollTop = highlightedItemRef.current.offsetTop;
    }

    // re-enable highlight on scroll after some time
    var timeout = setTimeout(function () {
      return setWithoutMouseHighlight(false);
    }, 500);
    return function () {
      return clearTimeout(timeout);
    };
  }, [shouldScrollToHighlight, highlightIndex]);
  return {
    withoutMouseHighlight: withoutMouseHighlight,
    scrollToHighlight: scrollToHighlight,
    preventScrollToHighlight: preventScrollToHighlight,
    disableMouseHighlighting: disableMouseHighlighting,
    highlightedItemRef: highlightedItemRef,
    listContainerRef: listContainerRef
  };
};
var _default = useHighlightInteraction;
exports["default"] = _default;